var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tree-select',{staticStyle:{"width":"100%"},attrs:{"tree-data":_vm.treeData,"placeholder":_vm.placeholder,"tree-checkable":"","show-checked-strategy":_vm.SHOW_PARENT},on:{"change":_vm.onChange},model:{value:(_vm.sValue),callback:function ($$v) {_vm.sValue=$$v},expression:"sValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }